<script lang="ts">
  import type {Collection, ExtendedPoem} from '../types'
  import api from '../api/api'
  import {modal} from '../stores/modal'
  import {t} from '../i18n'
  import {onMount} from 'svelte'
  import {user} from '../stores/user'
  import ModalTemplate from '../shared/ModalTemplate.svelte'
  import ValidationMessage from '../shared/ValidationMessage.svelte'
  import {flash} from '../stores/flash'

  export let poem: ExtendedPoem
  export let onSaved: (ids: number[]) => void

  let collections: Collection[] = []
  let collectionIds = poem.collection_ids
  let newCollection: Collection = {} as Collection
  let collectionsContainer: HTMLDivElement
  let errors: Record<string, string[]> = {}

  onMount(async () => {
    collections = await api.get<Collection[]>(`/users/${$user?.id}/collections`)
  })

  async function addToCollections(e: Event) {
    e.preventDefault()
    poem = await api.post(`/poems/${poem.id}/add_to_collections`, {collection_id: collectionIds})
    onSaved(collectionIds)
    modal.close()
    flash.show(t.poem.add_to_collection.added)
  }

  const createCollection = async (e: Event) => {
    e.preventDefault()

    errors = {}
    if (!newCollection.name) {
      errors.name = [t.errors.validation.required]
      return
    }

    try {
      const response = await api.post<Collection>('/collections', {collection: newCollection})
      collections = [response, ...collections]
      newCollection = {} as Collection
      collectionsContainer.scrollIntoView({behavior: 'smooth'})
    } catch (response: any) {
      errors = response.errors
    }
  }

  const onEnterCreateCollection = (e: KeyboardEvent) => {
    if (e.key === 'Enter') createCollection(e)
  }
</script>

<ModalTemplate size="tiny">
  <div class="modal-content">
    <div class="create__collection__form">
      <h2>{t.poem.add_to_collection.title}</h2>

      {#if collections.length > 0}
        <div class="coll-check-all" bind:this={collectionsContainer}>
          {#each collections as collection}
            <div class="coll-check-wrap">
              <div class="coll-check">
                <label>
                  <input type="checkbox" bind:group={collectionIds} value={collection.id}/>
                  <span>
                    <i/>
                    <span>{collection.name}</span>
                  </span>
                </label>
              </div>
            </div>
          {/each}
        </div>
      {/if}

      <div class="small-creat-coll">
        <a class="sc-btn" href="#" onclick={createCollection}>{t.poem.add_to_collection.create_new}</a>
        <input required bind:value={newCollection.name} placeholder={t.poem.add_to_collection.create} onkeydown={onEnterCreateCollection}/>
        <ValidationMessage errors={errors.name}/>
      </div>

      <button class="ui button black" onclick={addToCollections} disabled={!collectionIds.length}>
        {t.poem.add_to_collection.title}
      </button>
    </div>
  </div>
</ModalTemplate>

<style>
  .coll-check {
    margin-bottom: 5px;
  }
  .coll-check label {
    display: block;
    background: #f8f8fa;
    padding: 10px;
    cursor: pointer;
  }
  .coll-check span span {
    max-width: calc(100% - 40px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .coll-check input[type="checkbox"]+span i {
    display: inline-block;
    width: 24px;
    height: 24px;
    border: 2px solid #dedee1;
    border-radius: 50%;
    vertical-align: middle;
    margin-right: 10px;
  }
  .coll-check input[type="checkbox"]:checked+span i {
    background: url('/images/bcheck.svg') 50% 50% no-repeat;
    background-size: 13px 10px;
    border: 2px solid #000000;
  }
  .coll-check label i+span {
    display: inline-block;
    vertical-align: middle;
    color: #c1c1c6;
  }
  .coll-check input[type="checkbox"]:checked+span span {
    color: #000000;
  }
  .coll-check-all {
    max-height: 400px;
    overflow: scroll;
  }
  .small-creat-coll {
    position: relative;
    margin-bottom: 15px;
  }
  .sc-btn {
    position: absolute;
    right: 17px;
    bottom: 16px;
    font-size: 14px;
    padding: 3px 12px;
    background: #ececf0;
    display: inline-block;
  }
  .small-creat-coll input {
    border: 1px solid #d9d9dd;
    padding: 7px 100px 7px 15px;
    height: 58px;
    font-size: 14px;
    font-weight: 400;
  }
  .small-creat-coll input:focus {
    border-color: #1d1d1f;
  }
</style>